module.exports = __webpack_public_path__ + "img/denial.7bc8fc33.png";